import { useQuery } from "@tanstack/react-query";
import { projectDetailsApi } from "..";

export const useOverviewStats = (projectId: string | undefined) => {

    const { data, isFetching, isPending, isError } = useQuery({
        queryKey: ["project-overview-states", projectId],
        queryFn: () => projectDetailsApi.fetchProjectStats(projectId)
    });

    return {
        overviewStatsData: data?.data,
        isPending, isFetching, isError
    }

};